module.exports = __webpack_public_path__ + "static/signup-step-07519c02276f60baa23d7126bcac8e40.svg";